import { createLog } from '@/src/lib/logger'
import { ElMessage } from 'element-plus'
import { App } from 'vue'

const log = createLog('errorHandling')

export function setupErrorHandling(app: App) {
  // Global error handler for uncaught Vue component errors
  app.config.errorHandler = (err: any, instance: any, info: string) => {
    console.error('Vue error:', err, info)
    console.trace()
    const message =
      (err as { description?: string })?.description ||
      'An unexpected error occurred. Please refresh the page and try again.'
    ElMessage({
      type: 'error',
      message,
      duration: 5000,
    })
  }

  // Global error handler for unhandled promise rejections
  window.addEventListener(
    'unhandledrejection',
    (event: PromiseRejectionEvent) => {
      log('Unhandled promise rejection:', event.reason)
      const message =
        (event.reason as { description?: string })?.description ||
        'An error occurred while processing your request.'
      ElMessage({
        type: 'error',
        message,
        duration: 5000,
      })
      event.preventDefault() // Prevent default browser error logging
    }
  )

  window.addEventListener('error', function (event) {
    console.error(event)
    const message =
      event.message || 'An error occurred while processing your request.'
    ElMessage({
      type: 'error',
      message,
      duration: 5000,
    })
    //event.preventDefault() // Prevent default browser error logging
  })
}
